import { render, staticRenderFns } from "./tongzhilist.vue?vue&type=template&id=46e6b2e6&scoped=true&"
import script from "./tongzhilist.vue?vue&type=script&lang=js&"
export * from "./tongzhilist.vue?vue&type=script&lang=js&"
import style0 from "./tongzhilist.vue?vue&type=style&index=0&id=46e6b2e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e6b2e6",
  null
  
)

export default component.exports